import { Link } from "gatsby";
import Logo from "images/logo_menu.svg";
import IcoSearch from "images/search.svg";
import * as React from "react";
import { useLoc } from "../../hooks/useLoc";
import { Burger } from "../shared/base/burger";
import { Modal } from "../shared/base/modal";
import { useStickyHeader } from "./hooks/useStickyHeader";
import { MobileMenu } from "./menu";
import { SearchSelect } from "./header/search";
import { TemperatureUnitPicker } from "./unit-picker";
import { Icon, SvgIcon, Switch } from "@mui/material";
import { DestinationList } from "./destination-list";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import { scrollToFilter } from "../../services/scrollToFilter";

export const Header = ({ noFadedEdge = true }: { noFadedEdge?: boolean }) => {
    const [isShowPanel, setIsShowPanel] = React.useState(false);
    const [menuActive, setMenuActive] = React.useState(false);
    const [searchActive, setSearchActive] = React.useState(false);
    const [whereToTravelHovered, setWhereToTravelHovered] = React.useState(false);
    const headerRef = React.useRef(null);
    //const { showHeader, showFadedEdge } = useStickyHeader(headerRef, isHover);
    const showHeader = true;
    const showFadedEdge = false;
    const loc = useLoc();
    return (
        <header
            className={`fixed z-[500] h-[62px] w-full bg-white shadow-sm shadow-black/30 transition-[top] duration-300 md:h-[80px] 
            ${showHeader ? "top-0" : "top-[-120px]"}  ${
                showFadedEdge && !noFadedEdge && "md:header-fade md:shadow-none"
            }`}
            ref={headerRef}
        >
            <div className="flex h-full w-full items-center">
                <Link to="/" className="mx-4 md:mx-[28px]">
                    <div className="flex items-center">
                        <img
                            src={Logo}
                            alt="Sunheron logo"
                            className="h-[28px] w-[28px] transition duration-300 xs:h-[36px] xs:w-[36px] md:h-[40px] md:w-[40px]"
                        />
                        <div className="mx-[10px] flex flex-col items-start justify-center gap-[2px] xs:mx-[16px] md:mx-[28px]">
                            <span className="relative text-[20px] font-bold leading-none tracking-wide xs:text-[24px] md:text-[34px]">
                                Sunheron
                            </span>
                            <span className="text-[9px] font-semibold leading-none tracking-wide xs:text-[11px] xm:text-[12px] sm:text-[13px] md:text-[14px] lg:text-[15px]">
                                Your holiday finder
                            </span>
                        </div>
                    </div>
                </Link>
                {/* Show Panel Button */}
                <div
                    className="relative flex cursor-pointer flex-col items-center lgmax:hidden"
                    onMouseEnter={() => {
                        setWhereToTravelHovered(true);
                    }}
                    onMouseLeave={() => {
                        setWhereToTravelHovered(false);
                    }}
                    onClick={() => {
                        scrollToFilter();
                    }}
                >
                    <span className="text-[15px] font-semibold">
                        Where to travel
                    </span>
                    <div className={`rounded-full py-[2px] px-3 text-[12px] text-white ${whereToTravelHovered ? "bg-sh-red-dark" : "bg-sh-red"} transition duration-300`}>
                        Find best place for you -{"> "}
                    </div>
                </div>
                <div
                    className="relative flex h-full items-center mdmax:hidden"
                    onClick={() => {
                        setIsShowPanel(!isShowPanel);
                    }}
                    onMouseLeave={() => {
                        setIsShowPanel(false);
                    }}
                >
                    <button
                        className={`md:mx-[12px] lg:mx-[24px] rounded-md py-2 pl-4 pr-2 text-[15px] font-semibold transition ${
                            isShowPanel ? "bg-zinc-100" : "bg-white"
                        }`}
                        type="button"
                        onMouseEnter={() => setIsShowPanel(true)}
                    >
                        <span className="mr-2">Top destinations</span>
                        {!isShowPanel && (
                            <KeyboardArrowDownOutlinedIcon fontSize="small" />
                        )}
                        {isShowPanel && (
                            <KeyboardArrowUpOutlinedIcon fontSize="small" />
                        )}
                    </button>
                    {/* Expanding White Panel */}
                    <div
                        className={`fixed left-0 top-[74px] z-50 w-screen  transition-all duration-300 ease-in-out
                            ${
                                isShowPanel
                                    ? "pointer-events-auto h-[384px] opacity-100"
                                    : "pointer-events-none h-0 opacity-0"
                            }
                            shadow-top-bottom bg-white`}
                        style={{ minWidth: "100vw" }}
                    >
                        <div className="flex h-full w-full">
                            <DestinationList />
                        </div>
                    </div>
                </div>
                <div className="flex-1"></div>
                <div className="ml-[24px] mdmax:hidden">
                    <SearchSelect isMobile={false} />
                </div>
                <div className="relative mx-[16px] xsm:mx-[24px] text-center lg:mx-[24px] mdmax:top-[2px]">
                    <TemperatureUnitPicker />
                </div>
            </div>
        </header>
    );
};
